$(function () {
    //slider
    let slider = $('.slide > ul');
    let mytimeout;
    let nextSlide = (i) =>{
        let active = slider.find('li.active');
        let hGroup = active.find('h2');
        let index = active.index();
        let next;
        if (i != -1){
            if (index == 4){
                next = slider.find('li:first-child');
            }else{
                next = active.next();
            }
        }else{
            if (index == 0){
                next = slider.find('li:last-child');
            }else{
                next = active.prev();
            }
        }

        active.css('opacity','0');
        hGroup.removeClass('active');
        active.removeClass('active');
        var hGroupNext = next.find('h2');
        next.css('opacity','1');
        next.addClass('active');
        hGroupNext.addClass('active');
        mytimeout = 0;
    };
    let x = () => {
        mytimeout = setTimeout(function() {
            nextSlide();
            x();
        },6000);
    };
    let liActive = slider.find('li.active');
    liActive.find('h2').addClass('active');
    x();
    $('.leftArrow').click(function(){
        nextSlide(-1);
    });
    $('.rightArrow').click(function(){
        nextSlide();
    });

    $('.slide').mouseover(function(){
        clearTimeout(mytimeout);
    });
    $('.slide').mouseleave(function(){
        x();
    });
})
